// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackStartReturnRequestParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/order/trackStartReturnRequest";

const useTrackStartReturnRequest = (
    parameters: TrackStartReturnRequestParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.startReturnRequest, parameters, options);
};

export default useTrackStartReturnRequest;
